import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { WapReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: WapReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    wapAppIds: report.wapAppIds,
    msisdns: report.msisdns,
    operators: report.operators,
    operationIds: report.operationIds,
    sessionTypes: report.sessionTypes,
    sessionTags: report.sessionTags,
    sessionCloseReasons: report.sessionCloseReasons
  }
});
